import { Injectable, signal } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { CustomerBillingDto, SubscriptionPlanDto } from '../models/admin.models';
import { BaseResponse } from '../models/auth.models';
import { ApiService } from './api.service';

@Injectable({ providedIn: 'root' })
export class BillingService extends ApiService {
  private baseUrl = environment.apiUrl + '/api/billing';
  private plansUrl = environment.apiUrl + '/api/subscription-plans';

  /** Tenant darajasidagi modul ro'yxati — ShellComponent da bir marta yuklanadi */
  readonly includedModules = signal<string[]>([]);

  hasModule(name: string): boolean {
    return this.includedModules().includes(name);
  }

  getMyBilling(): Observable<BaseResponse<CustomerBillingDto>> {
    return this.http.get<BaseResponse<CustomerBillingDto>>(`${this.baseUrl}/my`);
  }

  getPublicPlans(): Observable<BaseResponse<SubscriptionPlanDto[]>> {
    return this.http.get<BaseResponse<SubscriptionPlanDto[]>>(this.plansUrl);
  }
}
